import { reactive } from "vue";
import Sidebar from "./SideBar.vue";
import SidebarLink from "./SidebarLink";

const sidebarStore = reactive({
  showSidebar: false,
  sidebarLinks: [],
  displaySidebar(value) {
    this.showSidebar = value;
  }
});

const SidebarPlugin = {
  install(app) {
    // Au lieu de Vue.prototype, on utilise globalProperties
    app.config.globalProperties.$sidebar = sidebarStore;

    // Enregistrer les composants de façon globale
    app.component("side-bar", Sidebar);
    app.component("sidebar-link", SidebarLink);
  }
};

export default SidebarPlugin;
